import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Tab, Tabs } from '@blueprintjs/core'

import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AsyncComponent from '@client/components/AsyncComponent'
import TabBuildLoading from './TabBuild/loading'
import TabDesignLoading from './TabDesign/loading'

import './styles.scss'

export const TabBuild = AsyncComponent({
  component: () => import('./TabBuild'),
  loading: TabBuildLoading,
})

export const TabDesign = AsyncComponent({
  component: () => import('./TabDesign'),
  loading: TabDesignLoading,
})

const SidebarDefault = ({ app = AppModelNULL, editor = EditorModelNULL }) => {
  const { formatMessage } = app
  const [activeTab, setActiveTab] = React.useState('tab-build')
  const handleTabChange = React.useCallback(
    (activeTabId) => {
      setActiveTab(activeTabId)
    },
    [setActiveTab]
  )
  return (
    <Tabs
      animate={false}
      renderActiveTabPanelOnly={true}
      selectedTabId={activeTab}
      onChange={handleTabChange}
      className={`${activeTab}-active`}
    >
      <Tab
        id="tab-build"
        title={formatMessage('sidebardefault.tab.build.title')}
        panel={<TabBuild />}
        className={'bp6-tab-2'}
      />
      <Tab
        id="tab-design"
        title={formatMessage('sidebardefault.tab.design.title')}
        panel={<TabDesign />}
        className={'bp6-tab-2'}
      />
    </Tabs>
  )
}

SidebarDefault.propTypes = {
  app: PropTypes.instanceOf(AppModel),
  editor: PropTypes.instanceOf(EditorModel),
}

export default inject('app', 'editor')(observer(SidebarDefault))
